// Module
var code = "<ng-form> <kform-builder-option-key></kform-builder-option-key> </ng-form> ";
// Exports
export default code;